const React = require("react");
const {openPopupWindow} = require("../../../../../../../emitters/popup");
const Popup = require("../../../../../../dumb/Popup/B");
const {FormWrapper, FormFooter} = require("../../../../../../dumb/FormHandlers");
const {apiAuthTfaDisable, apiAuthTfaVerify} = require("../../../../../../../api/_auth");
const {accountUpdate} = require("../../../../../../../emitters/account");

module.exports = () => (
  openPopupWindow((setState, self) => {
    const close = self.close;
    const resultModalData = [
      '2FA disabled',
      `You\'ve disabled 2FA linking for this account.`
    ];

    const onSubmit = () => (
      apiAuthTfaDisable().then(accountUpdate)
    )

    return () => {
      return (
        <Popup
          caption="Disable 2FA Code"
        >
          <FormWrapper
            onSubmit={onSubmit}
            resultModalData={resultModalData}
            onResult={close}
          >
            {(formCtx) => (
              <FormFooter
                submitBtnData={{
                  text: 'Disable 2FA',
                  changesCheckDisabled: true,
                  formCtx
                }}
                additionalBtnsList={[
                  {text: 'Cancel', onClick: close},
                ]}
              />
            )}
          </FormWrapper>
        </Popup>
      )
    }

  })
)
